<template>
<div class="">
<div>
  <a-dropdown style="display: inline-block; height: 100%; vertical-align: initial" >
    <span style="cursor: pointer">
      <a-avatar class="avatar" size="small" shape="circle" :src="currUser.avatar"/>
      <span v-text="getUserName()"></span>
    </span>
    <a-menu style="width: 150px" slot="overlay">
      <!--<a-menu-item>-->
        <!--<a-icon type="user" />-->
        <!--<span>个人中心</span>-->
      <!--</a-menu-item>-->
      <a-menu-item @click="changePas">
        <a-icon type="edit" />
        <span>修改密码</span>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
          <a-icon type="poweroff" />
          <span @click="logout">退出登录</span>
      </a-menu-item>
    </a-menu>
  </a-dropdown>

</div>
<a-modal
      title="修改密码"
      v-model="visible"
      :width="400"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
      @cancel="handleCancel"
      cancelText="取消"
      okText="确定"
      :record="record"
    >
      <a-form  :autoFormCreate="(form) => this.form = form" >
        <!--***************************************************************************-->
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item
              :label-col="formItemLayouts.labelCol"
              :wrapper-col="formItemLayouts.wrapperCol"
              label="原密码"
              fieldDecoratorId="loginPsw"
              :fieldDecoratorOptions="{initialValue: record.loginPsw,rules: [{ required: true, message: '原密码必填', whitespace: true}]}"
            >
              <a-input type="password"  placeholder="原密码"/>
            </a-form-item>
            <!--***************************************************************************-->
          </a-col>
          <a-col :span="24">
            <!--***************************************************************************-->
            <a-form-item
              :label-col="formItemLayouts.labelCol"
              :wrapper-col="formItemLayouts.wrapperCol"
              label="新密码"
              fieldDecoratorId="loginNewPsw"
              :fieldDecoratorOptions="{initialValue:record.loginNewPsw,rules: [{ required: true, validator: validateNewPassword, whitespace: true}]}"
            >
              <a-input type="password" placeholder="新密码"/>
            </a-form-item>
            </a-col>
            <a-col :span="24">
            <!--***************************************************************************-->
            <a-form-item
              :label-col="formItemLayouts.labelCol"
              :wrapper-col="formItemLayouts.wrapperCol"
              label="确认密码"
              fieldDecoratorId="loginNewPswT"
              :fieldDecoratorOptions="{initialValue:record.loginNewPswT,rules: [{ required: true, validator: validateConfirmPassword, whitespace: true}]}"
            >
              <a-input type="password" placeholder="确认密码"/>
            </a-form-item>
            <!--***************************************************************************-->
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
</div>
</template>

<script>
  import storage   from "../utils/storage";
  import { changePassWord } from '../service/changePas/changePasService';
    import info  from "../utils/hint";

  export default {
  name: 'HeaderAvatar',
  data () {
    return {
      visible: false,
      confirmLoading: false,
      record:{},
      formItemLayouts:{
        labelCol: { span: 5 },
        wrapperCol: { span: 19},
      }
    }
  },
  computed: {
    currUser () {
      return this.$store.state.account.user
    }
  },
  methods: {
    getUserName(){
       return storage.get('user')?storage.get('user').familyName+storage.get('user').firstName:'';
    },
    changePas(){
      this.visible= true
    },
     // 新密码验证规则
    validateNewPassword(rule, value, callback) {
      if (!value) {
        callback('新密码必填');
        return;
      }
      const form = this.form;
      const reg = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{12,30}$/;
      if (!reg.test(value)) {
        callback('密码中必须包含大小写字母、数字、特殊字符，至少12个字符，最多30个字符');
        return;
      }
      callback();
    },
    // 确认密码验证规则
    validateConfirmPassword (rule, value, callback) {
      if (!value) {
        callback('确认密码必填');
        return;
      }
      const form = this.form;
      if (value && value !== form.getFieldValue('loginNewPsw')) {
        callback('前后密码不一致');
      } else {
        callback();
      }
    },
    handleOk(e) {
      e.preventDefault();
      const { form } = this;
      form.validateFields((errors, values) => {
        if (errors) {
          return;
        }
        this.confirmLoading = true;
        let loginPsw = form.getFieldValue('loginPsw');
        let loginNewPsw = form.getFieldValue('loginNewPsw');
        const publicKey = window.RSAUtils.getKeyPair(sessionStorage.getItem('exponent'), '', sessionStorage.getItem('modulus'));
        loginPsw = window.RSAUtils.encryptedString(publicKey, loginPsw);
        loginNewPsw = window.RSAUtils.encryptedString(publicKey, loginNewPsw);
        const params = {
          loginPsw,
          loginNewPsw,
        };
        changePassWord(params)
          .then((data) => {
            this.handleCancel();
            if(info(data,"修改密码成功,即将退出登录")){
              setTimeout(() => {
                this.logout()
              }, 2000)
            }
            this.confirmLoading = false;
          })
          .catch(error => {
            this.confirmLoading = false;
          });
      });
      return false;
    },
    handleCancel(){
      this.visible =false
      this.form.resetFields();
    },
    logout(){
      storage.remove('user');
      storage.remove('token');
      storage.remove('routes');
      storage.remove('update')
      this.$router.replace({
        path: '/login',
      })
    },
  }
}
</script>

<style lang="less" scoped>
  .avatar{
    margin: 20px 4px 20px 0;
    color: #1890ff;
    background: hsla(0,0%,100%,.85);
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/HeaderlAvatar.vue